import React, { useContext, useEffect, useState } from 'react';
import Sidebar from '../../Components/SideBar';
import { Container, Row, Col, Card, Button, Table, Alert, Accordion } from 'react-bootstrap';

const Index: React.FC = () => {

  const [collapsed, setCollapsed] = useState(false);

  const handleMultipleApps = (id: number) => {


  }
  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const data = [
    {
      name: 'Identify ways to increase enrollment and revenue',
      items: [
        {
          name: 'Identify new program ideas',
          items: []
        },
        {
          name: 'Find programs to grow',
          items: []
        },
        {
          name: 'Recruit international students',
          items: []
        },
        {
          name: 'Identify new markets',
          items: []
        }
      ]
    }, {
      name: 'Ensure great outcomes for my students',
      items: [
        {
          name: 'Identify new program ideas',
          items: []
        },
        {
          name: 'Find programs to grow',
          items: []
        }
      ]
    }, {
      name: 'Find ways to reduce cost',
      items: [
        {
          name: 'Identify new program ideas',
          items: []
        },
        {
          name: 'Find programs to grow',
          items: []
        }
      ]
    }, {
      name: 'Inform instructional resource allocation and hiring decisions',
      items: [
        {
          name: 'Identify new program ideas',
          items: []
        },
        {
          name: 'Find programs to grow',
          items: []
        }
      ]
    }
  ]
  return (
    <Container fluid>
      <Row>
        <Col className="p-0" style={{ maxWidth: collapsed ? '80px' : '350px' }}>
          {/* <Sidebar collapsed={collapsed} onToggle={toggleSidebar} handleMultipleApps={handleMultipleApps} /> */}
        </Col>
        <Col className="p-3 transition-all">

          <div className='mb-4'>
            <h1>What would you like to do?</h1>
            {data.map((item) => {
              return <Accordion className='what rounded-0 mb-2' >
                <Accordion.Item eventKey="0" className=' rounded-0'>
                  <Accordion.Header className=' rounded-0'>{item.name}</Accordion.Header>
                  <Accordion.Body className='p-0 rounded-0'>
                    {item.items.map((subitem) => {
                      return <Accordion className='whatsub rounded-0 mb-2'>
                        <Accordion.Item eventKey="0" className=' rounded-0'>
                          <Accordion.Header className='rounded-0'>{subitem.name}</Accordion.Header>
                          <Accordion.Body className='rounded-0'>

                          </Accordion.Body>
                        </Accordion.Item>

                      </Accordion>
                    })}
                  </Accordion.Body>
                </Accordion.Item>

              </Accordion>
            })}

          </div>
        </Col>
      </Row >

    </Container >
  );
};

export default Index;
